// extracted by mini-css-extract-plugin
export var chip = "_e2-0";
export var filterDropdown = "_e2-5";
export var filterItem = "_e2-6";
export var icon = "_e2-1";
export var removeButton = "_e2-3";
export var removeIcon = "_e2-4";
export var separator = "_e2-2";